function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    "data-name": "Layer 1",
    viewBox: "0 0 544 518.89"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 427.32,
    height: 427.32,
    x: 83.98,
    y: 55.63,
    rx: 213.66,
    ry: 213.66,
    style: {
      fill: "#00333e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.01 201.25c-1.84-17.98-8.73-33.88-22.1-46.62-14.05-13.41-31.25-19.34-50.09-20.34-32.11-1.75-108.35-2.85-135.12 1.52-30.59 4.99-50.64 22.84-59.1 53.06-6.51 23.25-5.2 130.38-1.4 153.36 5.18 31.42 23.75 51.56 54.89 59.58 21.55 5.56 127.45 4.84 151.22.98 31.44-5.08 51.67-23.55 59.84-54.63 6.24-23.86 4.05-125.38 1.86-146.91m-25.13 136.51c-3.65 23.87-19.49 38.65-43.48 41.27-22.03 2.42-120.45 3.76-140.89-1.96-19.55-5.46-30.73-18.9-33.99-38.59-3.1-18.8-3.88-112.72-.05-137.86 3.6-23.66 19.43-38.42 43.28-41.09 24.2-2.71 111.29-3.02 134.48.53 23.81 3.65 38.57 19.52 41.19 43.55 2.44 22.42 3.15 110.05-.55 134.15ZM297.65 199.27c-38.69-.02-70.06 31.33-70.08 70.02s31.33 70.06 70.02 70.08 70.06-31.33 70.08-70.02-31.33-70.06-70.02-70.08m-.47 115.3c-25.02-.22-45.12-20.68-44.89-45.7.22-25.02 20.68-45.12 45.7-44.9s45.12 20.68 44.9 45.7-20.68 45.12-45.7 44.9Zm89.65-117.96c-.02 9.06-7.38 16.38-16.44 16.36s-16.38-7.38-16.36-16.44 7.38-16.38 16.44-16.36 16.38 7.38 16.36 16.44",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgInstagram;